/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_Panel_BadgeInputs */

const en_mk_proof_panel_badge = /** @type {(inputs: Mk_Proof_Panel_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verified`)
};

const id_mk_proof_panel_badge = /** @type {(inputs: Mk_Proof_Panel_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`terverifikasi`)
};

/**
* | output |
* | --- |
* | "verified" |
*
* @param {Mk_Proof_Panel_BadgeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_panel_badge = /** @type {((inputs?: Mk_Proof_Panel_BadgeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_Panel_BadgeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_panel_badge(inputs)
	return en_mk_proof_panel_badge(inputs)
});